<div @slideDownUp class="card relative">
  <form id="login-form" [formGroup]="formLogin" class="relative" *ngIf="!alreadyLoged">
    <div class="w-full flex flex-col items-center justify-center" *ngIf="!execLogout">

      <div class="text-left w-11/12 ">
        <h1 class=" text-bold ">Accedi</h1>
        <p class="text-lg text-bold ">Inserisci le tue credenziali</p>
      </div>

      <div class="w-11/12 mt-5">



        <label for="username" class="text-gray-500">Username</label><br />
        <div class="relative mb-2">
          <input id="username" formControlName="username" class="e-input transform duration-300" (keyup.enter)="login()"
            placeholder="Inserisci l'username " />
        </div>

        <label for="pwdInput" class="text-gray-500">Password</label><br />

        <div class="relative ">
          <input #pwdInput id="pwdInput" type="password" formControlName="password" (keyup.enter)="login()"
            class="e-input pwdinput transform duration-300" placeholder="Inserisci la password " />
          <div [class]="passwIcon" class="absolute top-0 right-0 pwdicon flex content-center items-center align-middle"
            (click)="showPassword()"></div>
        </div>


        <a routerLink="/auth/reset"
          class="text-sm font-medium text-slate-400 hover:text-white transform duration-300">Password dimenticata?</a>
        <div class="flex flex-col justify-center ">


          <!--<div class="mb-2">
        <ejs-checkbox label="Ricordami"></ejs-checkbox>
      </div>-->

          <div class="relative mt-2 mb-2 ">
            <button type="submit"
              class="{{formLogin.invalid ? 'p-2 w-full rounded-2xl bg-primary-50 text-primary-300' : 'bg-emerald-600 hover:bg-emerald-900 focus:bg-emerald-800 p-2 w-full rounded-2xl text-white up-on-hover'}} transform duration-300 "
              (click)="login()" [disabled]="formLogin.invalid">
              Accedi
            </button>
          </div>

          <a routerLink="/auth/register"
            class="text-sm font-medium text-slate-400 hover:text-white transform duration-300">Nuovo utente?</a>

        </div>

        <!-- <div style="font-size: 10px;color:gray; padding-top:1em; width: 25em;">
        This site is protected by reCAPTCHA and the Google
        <a href="https://policies.google.com/privacy">Privacy Policy</a> and
        <a href="https://policies.google.com/terms">Terms of Service</a>
        apply.
      </div> -->





        <ejs-message class="error-msg" severity="Error" [visible]="formHaveErrors" [content]="errMsg"></ejs-message>

        <ejs-message *ngIf="!rispLogin.response.success" class="error-msg" severity="Error"
          [visible]="!rispLogin.response.success" [content]="rispLogin.response.error"></ejs-message>


        <ejs-message *ngIf="showTimer" class="error-msg" severity="Error" [visible]="showTimer">
          <p>{{ secondsRemaining$ | async }}</p>
        </ejs-message>

        <ejs-message *ngIf="microsoftError" class="error-msg" severity="Error" [content]="'Autenticazione annullata'">
        </ejs-message>

        <div *ngIf="showRegisteredMessagge" class="my-4 bg-red-500/40 rounded-2xl p-4 flex"> 
          <span class="text-red-800 font-semibold text-lg">Il tuo account è stato creato. Attendi che venga autorizzato prima di poter accedere</span>
        </div>

        <!-- 
        <script src="https://www.google.com/recaptcha/api.js" async defer></script>
        <script>
          function onSubmit(token) {
            document.getElementById("login-form").submit();
          }
        </script> -->

        <!-- <re-captcha
          siteKey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
          #captchaRef="reCaptcha"
          (resolved)="resolved($event)"
          (errored)="onError($event)"
          errorMode="handled"
          size="invisible"></re-captcha> -->

       <!--  <div class="w-full flex items-center justify-center gap-2 mt-2 mb-1">
          <div class="border-split-login w-full h-1">

          </div>
          <div class="border-split-login-text font-bold">
            O
          </div>
          <div class="border-split-login w-full h-1">

          </div>
        </div> -->

     <!--    <div class="microsoft-login transition-all duration-300 w-full" *ngIf="!execLogout">
          <button (mouseenter)="logoChange = true" (mouseleave)="logoChange = false"
            class="flex items-center justify-evenly text-primary-300 w-full hover:text-white rounded-2xl p-4 mt-2 border border-primary-50 shadow-md hover:bg-primary-300"
            (click)="loginPopup()">

            <svg xmlns="http://www.w3.org/2000/svg" class="w-10 h-10" viewBox="0 0 21 21" *ngIf="logoChange">
              <rect x="1" y="1" width="9" height="9" fill="currentColor" />
              <rect x="1" y="11" width="9" height="9" fill="currentColor" />
              <rect x="11" y="1" width="9" height="9" fill="currentColor" />
              <rect x="11" y="11" width="9" height="9" fill="currentColor" />
            </svg>


            <svg xmlns="http://www.w3.org/2000/svg"  class="w-10 h-10"viewBox="0 0 21 21" *ngIf="!logoChange">
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>

            <div class="">
              Accedi con Microsoft
            </div>

          </button>
        </div> -->

      </div>
    </div>

    <div *ngIf="execLogout" class="flex flex-col justify-center items-center w-full h-full ">
      <app-loading-animation></app-loading-animation>
    </div>



  </form>



  <!--<div class="microsoft-login">
    <button class="rounded-2xl p-4 m-1 bg-red-200 hover:bg-red-400" (click)="logoutPopup()">
      LOGOUT M
    </button>
  </div>-->


  <div @slideDownUp class="w-fullrelative" *ngIf="alreadyLoged">


    <div @slideDownUp class="w-full flex flex-col justify-center items-center text-red-500 mb-4" *ngIf="!execLogout">

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" class="w-24 h-24 ">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 9v4" />
        <path
          d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" />
        <path d="M12 16h.01" />
      </svg>

      <p class="text-center text-lg  font-semibold">Abbiamo rilevato una sessione attiva.<br>
        Procedendo con il login, verrai disconnesso da tutte le altre sessioni attive.</p>
    </div>

    <div class="flex flex-row justify-center gap-4 w-full" style="z-index: 1000001;" *ngIf="!execLogout"
      [ngClass]="{'h-24': execLogout}">
      <button (click)="cancelPopClick()"
        class="bg-red-600 hover:bg-red-800 p-2 w-full rounded-2xl transform duration-300 text-white shadow-lg"
        style="z-index: 100001;">
        Annulla
      </button>

      <button (click)="okPopClick()" id="confirm-login-button"
        class="bg-emerald-600 hover:bg-emerald-800 p-2 w-full rounded-2xl transform duration-300 text-white shadow-lg"
        style="z-index: 100001;">
        Continua
      </button>
    </div>



    <div @slideDownUp *ngIf="execLogout == true" class="">
      <app-loading-animation></app-loading-animation>
    </div>
  </div>


</div>